import { callApi } from "./api.service";

export const Resubscribe = async (
  data:any
) => {
    return await callApi(`/api/notifications/resubscribe?email=${data.email}&type=${data.type}`, "POST", false);
};